<template>
    <section class="cover hero-banner" :style="bgImg" >
        <div class="container px-lg-5">
            <div class="p-4 p-lg-5 inner-bg">
                <div class="row">
                    <div class="col-md-7 col-sm-12">
                        <h1 class="hero-title">
                            Saving just got easier! Go solo or as a group
                        </h1>
                        <p class="description">Get money savvy with smarter saving and spend tracking.</p>

                        <ul class="list-unstyled apps-store">
                            <li>
                                <a href="">
                                    <img src="../assets/img/icons/googleplay.png" alt="Google Play">
                                </a>
                            </li>
                            <li>
                                <a href="">
                                    <img src="../assets/img/icons/download-apple.png" alt="App Store">
                                </a>
                            </li>
                        </ul>
                    </div>
                    
                    <div class="col-md-5 off">
                        <div class="row">
                            <div class="col-md-6 ">
                                <div class="img1">
                                    <img class="img-responsive" :src="iphone2" alt="">
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <div class="img2">
                                    <img class="img-responsive" :src="iphone1" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data (){
            return {
                bgImg: {
                    background: `#f6f6f6 url(${require("../assets/img/bg/coin-bg.png")})`
                },
                iphone2: require("../assets/img/features/m11.png"),
                iphone1: require("../assets/img/features/m12.png"),
            }
        }
    }
</script>

<style>
.first-col{
    padding-top:5%;
}
.inline-display{
    display: flex;
}
.iphone1-img{
    width:100%;
    /* display: flex; */
    margin-top:-50%;
}
.iphone2-img{
    width:100%;
    bottom:0;
    position: 0 0 0 0;
    height:100%;
    margin-bottom:-50%;
}
.hero-content {
    background-color: white;
    padding:5% 0% 5% 2%;
    width:85%;
    border-radius:25px;
    text-align: left;
    margin-top:-10%
    }
.text-title{
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: 900;
    font-size: 72px;
    line-height: 80px;
    /* or 111% */
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;

    /* Green/100 */
    color: #214F4D;

}
.text-content{
    font-family: Nunito Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    /* identical to box height */
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;

    /* Green/100 */
    color: #214F4D;

}
.app-download-icon{
    display: flex;
    align-items: left;
    letter-spacing: 0.05em;
}
.img-fluid{
    padding:3%;
    border-radius: 15px;
}
</style>
